import { createApp } from 'vue'
import App from './App.vue'
import router from '~/route'
import store from '~/store/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import 'ant-design-vue/dist/antd.dark.css'
import '~/utils/permissions'

const app = createApp(App)
app.use(Antd)
app.use(router)
app.use(store)
app.mount('#app')
